import $ from 'jquery';

class Mergetool {
	
	constructor() {
		if ($("#merge-tool").length > 0) {
			try {
				this.init(window.mergeToolClients);
			} catch(ex) {
				// form not found...
			}

		}
	}
	
	init(clients) {
		Vue.component('merge-tool', () => import('../components/MergeTool.vue'));

		this.vm = new Vue({
			el: "#merge-tool",
			data() {
				return {clients}
			}
		});
	}

}

export default Mergetool;
